import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { getContentUnlockStatus } from "@/lib/content-gate.functions";

export const Route = createFileRoute("/content")({
  beforeLoad: async ({ location }) => {
    if (location.pathname === "/content/unlock") return;
    const { unlocked } = await getContentUnlockStatus();
    if (!unlocked) {
      throw redirect({ to: "/content/unlock" });
    }
  },
  component: () => <Outlet />,
});
